'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import posthog from 'posthog-js';
import { usePathname, useSearchParams } from 'next/navigation';
// eslint-disable-next-line no-restricted-imports
import useEventListener from '@/hooks/useEventListener';
import type { User, Tenant } from '@/modules/tenant';
export const PostHogTracker = t0 => {
  const $ = _c(14);
  const {
    user,
    tenant
  } = t0;
  const pathname = usePathname();
  const t1 = useSearchParams();
  let t2;
  if ($[0] !== t1) {
    t2 = t1.toString();
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const searchParamsString = t2;
  let t3;
  if ($[2] !== pathname || $[3] !== searchParamsString) {
    t3 = [pathname, searchParamsString];
    $[2] = pathname;
    $[3] = searchParamsString;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(_temp, t3);
  useEventListener("beforeunload", _temp2);
  let t4;
  if ($[5] !== user) {
    t4 = () => {
      if (user?.id) {
        posthog?.identify(user.id, {
          name: user.name,
          email: user.email
        });
      }
    };
    $[5] = user;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = user?.id;
  const t6 = user?.name;
  const t7 = user?.email;
  let t8;
  if ($[7] !== t5 || $[8] !== t6 || $[9] !== t7) {
    t8 = [t5, t6, t7];
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  useEffect(t4, t8);
  let t10;
  let t9;
  if ($[11] !== tenant) {
    t9 = () => {
      if (tenant) {
        posthog?.group("tenant", tenant);
      }
    };
    t10 = [tenant];
    $[11] = tenant;
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  useEffect(t9, t10);
  return null;
};
export default PostHogTracker;
function _temp() {
  posthog.capture("$pageview");
}
function _temp2() {
  posthog.capture("$pageleave");
}